module.exports = __webpack_public_path__ + "img/wiaa.a7b36650.png";